import { Badge } from '../../../ui';
import type { OveroptLevel } from './format';

/** The keyword density screen's level as a badge; nothing when density is in line. */
export default function OveroptBadge({ level }: { level: OveroptLevel | null }) {
  if (level === 'over') return <Badge tone="down">over-optimized</Badge>;
  if (level === 'under') return <Badge tone="warn">under-optimized</Badge>;
  return null;
}
